RivalIQ.module('suggestion.views', function (views, App, Backbone, Marionette, $, _, CompareData, formatter, s) {

    'use strict';

    views.Handle = Marionette.ItemView.extend({
        template: '#suggestionModalHandle',
        templateHelpers: function () {
            const me = this;

            const source = me.model.get('source');
            const details = CompareData.sourceDetails[source];
            const display = me.getDisplayData();
            const model = me.model.toJSON();
            display.shortDescription = s.prune(display.description || model.description || model.about, 265);

            model.data = model.data || {};
            const iconUrl = model.data.icon_url || model.data.iconUrl;

            return _.extend({
                name: null,
                iconUrl: iconUrl,
                details: details,
                formatter: formatter.formats,
                handle: model.handle || model.native_id
            }, display);
        },
        getDisplayData: function () {
            const me = this;

            const source = me.model.get('source');
            switch (source) {
                case CompareData.sources.TWITTER:
                    return {
                        handle: `@${me.model.get('handle')}`,
                        reach: me.model.get('followers_count')
                    };

                case CompareData.sources.FACEBOOK:
                    return {
                        name: me.model.get('name'),
                        reach: me.model.get('fan_count')
                    };

                case CompareData.sources.YOUTUBE: {
                    const statistics = me.model.get('statistics') || {};
                    const snippet = me.model.get('snippet') || {};
                    return {
                        reach: statistics.subscriberCount,
                        description: snippet.description
                    };
                }
                case CompareData.sources.INSTAGRAM:
                    return {
                        reach: me.model.get('followers_count'),
                        description: me.model.get('biography'),
                        iconUrl: me.model.get('profile_picture_url')
                    };

                case CompareData.sources.TIKTOK: {
                    const user = me.model.get('user') || {};
                    const stats = me.model.get('stats') || {};

                    return {
                        name: user.nickname || '',
                        handle: `@${user.uniqueId}`,
                        description: user.signature || '',
                        reach: stats.followerCount
                    };
                }

                default:
                    throw new Error(`handle - Display Data - unknown source ${source}`);
            }
        }
    });

}, RivalIQ.data.CompareData, RivalIQ.formatter, window.s);
